import 'babel-polyfill'
import React, {Component} from 'react'
import ReactDOM from 'react-dom'

import {configure} from 'mobx'

configure({
    isolateGlobalState: true,
})

import SettingsController from './controller/SettingsController'

window.shop_pokupki_plugin_settings_controller = new SettingsController()